import React from 'react';
import { LABEL } from '../../veriables';
import cn from 'classnames';
import style from './index.module.scss';

const Footer = (props) => {
  // background-secondary od-container-card-background
  return props.isFooter && (
    <div className="h-100 w-100 row align-items-center fw-600 od-text-primary justify-content-center p-2 mx-0 fs-14">
      {props.enableRequestAssistance && (
        //  { 'col-6': !props.startOverBtn }, { 'col-6': !props.enableAccessibility }
        <div role="presentation" onClick={() => !props.isAssisstanceCalled && props.callserver()} className={cn('pl-0 col-4')}>
          <div className="col-12 p-0">
            <div className={cn('col-12 m-0 row align-items-center justify-content-center text-center od-container-card-border btn35', props.isAssisstanceCalled ? `${style.card} btn-primary btn-ripple od-btn-primary` : 'card btn-secondary od-btn-secondary')}>
              <div className="fs-14">{LABEL().NEED_ASSISTANCE}</div>
            </div>
          </div>
        </div>
      )}
      {props.startOverBtn && (
      // { 'col-6': !props.enableRequestAssistance }, { 'col-6': !props.enableAccessibility }, { 'col-4': !props.enableAccessibility && !props.enableRequestAssistance }
      <div role="presentation" onClick={() => props.startOver()} className={cn('col-4 p-0')}>
        <div className={cn('col-12 p-0')}>
          <div className="col-12 card m-0 row align-items-center justify-content-center p-1 text-center od-container-card-border btn35 btn-secondary od-btn-secondary">
            <div className="fs-14">{LABEL().START_OVER}</div>
          </div>
        </div>
      </div>
      )}
      {props.enableAccessibility && (
        // { 'col-6': !props.startOverBtn }, { 'col-6': !props.enableRequestAssistance }
        <div role="presentation" onClick={() => props.postEvent()} className={cn('pr-0 col-4')}>
          <div className="col-12 p-0">
            <div className={cn('col-12 m-0 row align-items-center justify-content-center  p-1 text-center od-container-card-border btn35', props.isHeight ? `${style.card} od-container-card-background btn-primary btn-ripple od-btn-primary` : 'card btn-secondary od-btn-secondary')}>
              <div className="fs-14">{LABEL().ACCESSIBILITY} <i className="fa fa-wheelchair" aria-hidden="true" /></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
